
import React, { useRef } from 'react';
import { useSitewide } from '@mfe/sitewide';
import { Interpolation, Theme } from '@core-ui/react-stitch/types';
import Scrollable from './styled/Scrollable';
import { isScrollable, isTop } from '../../collaborators/positions';

interface DesktopProps {
  children: ComponentProps[],
}

interface ComponentProps extends Node {
  props: {
  }
}

const Desktop = (props: DesktopProps) => {
  const {
    children,
  } = props;

  const desktopStyles = (): Interpolation<Theme> => ({
    boxSizing: 'border-box',
    width: '16rem',
    '.mkt-svg-overlay': {
      '& picture': {
        maxWidth: '15rem',
        marginLeft: '.5rem',
      },
    },
  });
  const { totalStickyElementHeight } = useSitewide();
  const scrollableRef = useRef<HTMLDivElement>(null);
  const scrollableElementScrollTop = useRef(0);
  const elements = React.Children.map(children, child => child) ?? [];
  const topElements = elements.filter(isTop);
  const scrollableElements = elements.filter(isScrollable);
  const onScroll = () => {
    if (scrollableRef?.current?.scrollTop) {
      scrollableElementScrollTop.current = scrollableRef.current?.scrollTop;
    }
  };
  const onClick = () => {
    scrollableRef.current?.scrollTo(0, scrollableElementScrollTop.current);
  };

  return (
    <div css={desktopStyles}>
      {topElements}
      <Scrollable
        ref={scrollableRef}
        onClick={onClick}
        onScroll={onScroll}
        totalStickyElementHeight={totalStickyElementHeight as number}
      >
        {scrollableElements}
      </Scrollable>
    </div>
  );
};

export default Desktop;
